module.exports = __webpack_public_path__ + "static/media/oblong_d.2b8858f9.svg";